import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCarapaJVcD6kk2mk2H2-VG7HIunRTEvLo",
    authDomain: "todo-app-209e7.firebaseapp.com",
    projectId: "todo-app-209e7",
    storageBucket: "todo-app-209e7.appspot.com",
    messagingSenderId: "354430162160",
    appId: "1:354430162160:web:0d0019e4e0a61dc6831e35"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };